import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
const Testimonials = lazy(() => import('./components/Testimonials').then(m => ({
  default: m.Testimonials
})));
const ProblemSection = lazy(() => import('./components/ProblemSection').then(m => ({
  default: m.ProblemSection
})));
const TomosSection = lazy(() => import('./components/TomosSection').then(m => ({
  default: m.TomosSection
})));
const BonusSection = lazy(() => import('./components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const ProductCarousel = lazy(() => import('./components/ProductCarousel').then(m => ({
  default: m.ProductCarousel
})));
const CountdownTimer = lazy(() => import('./components/CountdownTimer').then(m => ({
  default: m.CountdownTimer
})));
const PricingSection = lazy(() => import('./components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const SistemaOperativoSection = lazy(() => import('./components/SistemaOperativoSection').then(m => ({
  default: m.SistemaOperativoSection
})));
const ComparisonTableExtended = lazy(() => import('./components/ComparisonTableExtended').then(m => ({
  default: m.ComparisonTableExtended
})));
const TestimonialsPreGuarantee = lazy(() => import('./components/TestimonialsPreGuarantee').then(m => ({
  default: m.TestimonialsPreGuarantee
})));
const Guarantee = lazy(() => import('./components/Guarantee').then(m => ({
  default: m.Guarantee
})));
const FAQ = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQ
})));
const ComparisonTable = lazy(() => import('./components/ComparisonTable').then(m => ({
  default: m.ComparisonTable
})));
const FinalCTA = lazy(() => import('./components/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
const PurchasePopup = lazy(() => import('./components/PurchasePopup').then(m => ({
  default: m.PurchasePopup
})));
export function App() {
  useEffect(() => {
    // Google Tag (gtag.js)
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = 'https://www.googletagmanager.com/gtag/js?id=G-CMW0KCF36F';
    document.head.appendChild(script1);
    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-CMW0KCF36F');
    `;
    document.head.appendChild(script2);
    const preconnects = [{
      rel: 'preconnect',
      href: 'https://fonts.googleapis.com'
    }, {
      rel: 'preconnect',
      href: 'https://fonts.gstatic.com',
      crossOrigin: 'anonymous'
    }, {
      rel: 'preconnect',
      href: 'https://cdn.magicpatterns.com'
    }, {
      rel: 'dns-prefetch',
      href: 'https://fonts.googleapis.com'
    }, {
      rel: 'dns-prefetch',
      href: 'https://cdn.magicpatterns.com'
    }];
    preconnects.forEach(attrs => {
      const link = document.createElement('link');
      Object.entries(attrs).forEach(([key, val]) => link.setAttribute(key, val as string));
      document.head.appendChild(link);
    });
  }, []);
  return <div className="min-h-screen bg-[#0B0B12] font-sans selection:bg-brand-gold selection:text-black text-slate-100" data-id="element-0">
      <Hero data-id="element-1" />
      <SocialProof data-id="element-2" />

      <Suspense fallback={<div className="h-20" data-id="element-4" />} data-id="element-3">
        <Testimonials data-id="element-5" />
        <ProblemSection data-id="element-6" />
        <div className="bg-[#0B0B12] py-12 border-y border-white/5" data-id="element-7">
          <div className="max-w-xl mx-auto px-5 text-center" data-id="element-8">
            <p className="text-white font-black text-[18px] leading-tight uppercase tracking-wider" data-id="element-9">
              ESTO NO ES SOLO MATERIAL PARA LEER.
              <br data-id="element-10" />
              <span className="gold-text-gradient" data-id="element-11">
                ES UN SISTEMA PROFESIONAL PARA PELUQUERÍA REAL
              </span>
            </p>
          </div>
        </div>
        <TomosSection data-id="element-12" />
        <BonusSection data-id="element-13" />
        <ProductCarousel data-id="element-14" />
        <CountdownTimer data-id="element-15" />
        <PricingSection data-id="element-16" />
        <SistemaOperativoSection data-id="element-17" />
        <ComparisonTableExtended data-id="element-18" />
        <TestimonialsPreGuarantee data-id="element-19" />
        <Guarantee data-id="element-20" />
        <FAQ data-id="element-21" />
        <ComparisonTable data-id="element-22" />
        <FinalCTA data-id="element-23" />

        <div className="max-w-xl mx-auto px-5 py-6 text-center" data-id="element-24">
          <p className="text-white text-lg font-black uppercase tracking-tight" data-id="element-25">
            PORQUE UNA COSA ES SABER HACER PELUQUERÍA.
          </p>
          <p className="text-2xl font-black mb-4 gold-text-gradient" data-id="element-26">
            👉 Y OTRA MUY DISTINTA ES TRABAJAR COMO UNA PROFESIONAL
            ESTRUCTURADA.
          </p>
          <p className="text-white text-3xl font-black" data-id="element-27">
            💥 Y eso puede cambiar muchísimo tu día a día.
          </p>
        </div>

        <PurchasePopup data-id="element-28" />
      </Suspense>
    </div>;
}